import { defineStore } from 'pinia';

// Define types for better type safety
export interface FeatureFlags {
  timeOffsetEnabled: boolean;
  experimentalFeatures: boolean;
  debugMode: boolean;
  showUnreadIndicator: boolean;
}

interface DevToolsState {
  isOpen: boolean;
  activePanel: string;
  featureFlags: FeatureFlags;
  viewSpecificTools: Record<string, any>;
}

export const useDevToolsStore = defineStore('devTools', {
  state: (): DevToolsState => ({
    isOpen: false,
    activePanel: 'general', // Which panel is currently active
    featureFlags: {
      timeOffsetEnabled: false,
      experimentalFeatures: false,
      debugMode: false,
      showUnreadIndicator: false,
      // Add more feature flags as needed
    },
    viewSpecificTools: {}, // Store view-specific tool states
  }),
  actions: {
    toggle() {
      this.isOpen = !this.isOpen;

      // When opening, add a class to the body to prevent scrolling
      if (this.isOpen) {
        document.body.classList.add('dp3-devtools-open');
      } else {
        document.body.classList.remove('dp3-devtools-open');
      }
    },
    setActivePanel(panel: string) {
      this.activePanel = panel;
    },
    toggleFeatureFlag(flag: keyof FeatureFlags) {
      this.featureFlags[flag] = !this.featureFlags[flag];
    },
    // Save view-specific tool state
    saveViewState(viewName: string, state: any) {
      this.viewSpecificTools[viewName] = state;
    },
  },

  persist: {
    key: 'dp3-devtools',
    paths: ['featureFlags'], // Only persist feature flags, not panel state or open state
  } as any, // Type assertion to avoid persist plugin typing issues
});
